export function getMainDomain(hostname = window.location.host) {
    return hostname;
}
/**
 * |===============================================|
 * | url structure                                 |
 * | |https:|//|bf-api|-dev|.|golden168.win|/api|  |
 * | |^^^^^^|  |^^^^^^|^^^^| |^^^^^^^^^^^^^|^^^^|  |
 * | protocol    sub   stage   main domain prefix  |
 * |===============================================|
 */
const URLS = {
    main: { protocol: 'https:', sub: '', prefix: '' },
    mainV2: { protocol: 'https:', sub: 'v2', prefix: '' },
    mainAg: { protocol: 'https:', sub: 'ag', prefix: '' },
    mainMg: { protocol: 'https:', sub: 'mg', prefix: '' },
    lottery: { protocol: 'https:', sub: 'lottery', prefix: '' },
    bf: { protocol: 'https:', sub: '', prefix: '/bf' },
    bfAdmin: { protocol: 'https:', sub: '', prefix: '/bf/admin' },
    api: { protocol: 'https:', sub: '', prefix: '/ga/api' },
    ws: { protocol: 'https:', sub: '', prefix: '' },
    liveWs: { protocol: 'https:', sub: '', prefix: '' },
    liveAPI: { protocol: 'https:', sub: '', prefix: '' },
    bfAPI: { protocol: 'https:', sub: '', prefix: '/bf-api/api' },
    bfWS: { protocol: 'wss:', sub: '', prefix: '/bf-ws/ws' },
    appAPI: { protocol: 'https:', sub: '', prefix: '/app/api' },
    app: { protocol: 'https:', sub: '', prefix: '/app' },
    xwApp: { protocol: 'https:', sub: '', prefix: '/xw-download' },
    image: { protocol: 'https:', sub: '', prefix: '/images' },
    botionStatic: { protocol: 'https:', sub: '', prefix: '/botion-static' },
    botionBcaptcha: { protocol: 'https:', sub: '', prefix: '/botion-bcaptcha' },
    netshuntStatic: { protocol: 'https:', sub: '', prefix: '/netshunt-static' },
    netshuntBcaptcha: { protocol: 'https:', sub: '', prefix: '/netshunt-bcaptcha' },
    hfAPI: { protocol: 'https:', sub: '', prefix: '/hf/api' },
    openIMAdmin: { protocol: 'https:', sub: '', prefix: '/xw' },
    openIMAdminAPI: { protocol: 'https:', sub: '', prefix: '/xw-api/api' },
    streamerControlAdminUpdater: { protocol: 'https:', sub: '', prefix: '/streamer-control-admin/current/latest.json' }
};
const BACKEND_URLS = ['api', 'ws', 'liveWs', 'bfAPI', 'bfWS', 'image', 'hfAPI', 'openIMAdminAPI', 'streamerControlAdminUpdater'];
/**
 * 得到各系統的完整 URL
 * 這個 function 不處理不同主 domain 問題，請自行帶入已知主 domain。
 * 例如：在代理後臺訪問客服系統時，主 domain 不同，請自行換上新的主 domain。
 * @param stage 現在的環境
 * @param mainDomain 主域名，預設：現在瀏覽器的主域名
 */
export function goldenURL(mainDomain = getMainDomain(), clientProtocol = window.location.protocol, backendDomain = mainDomain) {
    return {
        mainDomain,
        clientProtocol,
        backendDomain,
        get(name) {
            const domain = BACKEND_URLS.includes(name) ? backendDomain : mainDomain;
            const isDash = domain.startsWith('dev') || domain.startsWith('alpha');
            const protocol = clientProtocol === 'https:' ? URLS[name].protocol : URLS[name].protocol.replace('s:', ':');
            // eslint-disable-next-line sonarjs/no-nested-template-literals
            return `${protocol}//${URLS[name].sub.length > 0 ? `${URLS[name].sub}${isDash ? '-' : '.'}` : ''}${domain}${URLS[name].prefix}`;
        }
    };
}
//# sourceMappingURL=index.js.map